export class ItemDetailModel {
  pk: number;
  transName: string;
  fromLocName: string;
  toLocName: string;
  descr: string;
  imgURL: any;
  createWho: string;
  userName: string;
  createDate: Date;
  selectedImageUrl: any;
}



// WEBPACK FOOTER //
// D:/projects/feelway-pawnshop/pawnshop-web-client-feelway/src/app/pages/common/models/item-detail.model.ts